const DropzoneConstants = {
    DROPZONE_MAX_FILESIZE: 25000000,
    MAIN_TEXT: {
        MOBILE: 'Tap here to add photos.',
        DESKTOP: 'Drop photos here or click to upload.',
    },
    SUB_TEXT: {
        MOBILE: 'Tap an uploaded photo to add a caption.',
        DESKTOP: 'Click an uploaded photo to add a caption or rotate.',
    },
};

export default DropzoneConstants;
